import "./App.css";
import React from "react";
import { Route, Routes } from "react-router-dom";
import Login from "./Components/Login/Login";
import Home from "./Components/Home/Home";
import Dashboard from "./Components/Dashboard/Dashboard";
import Stocks from "./Components/Product/Stocks";
import AdminDashboard from "./Admin/pages/AdminDashboard";
import Sales from "./Components/Sales/Sales";
import ProtectedRoutes from "./ProtectedRoutes";
import AddProduct from "./Components/Product/AddProduct";
import ShortageSTocks from "./Components/ShortageStocks/ShortageStocks";
import CreateStore from "./Admin/createAccount/CreateStrore";
import CreateUser from "./Admin/createAccount/CreateUsers";
import StoreStocks from "./Admin/pages/StoreStocks";
import Store from "./Admin/pages/Store";
import StoreSales from "./Admin/pages/StoreSales";
import Gdigital from "./Admin/pages/Gdigital";
import Filter from "./Admin/pages/Filter";
import SalesFilter from "./Admin/pages/Billing/SalesFilter";
import AttendanceReport from "./Components/Attendance/AttendanceReport";
import Expenses from "./Components/Expenses/Expenses";
import AddExpenses from "./Components/Expenses/AddExpenses";
import AccountsExpenses from "./Components/Expenses/AccountsExpenses";
import HrAttendanceDashboard from "./Components/Attendance/HrAttendanceDashboard";
import CustomerLogin from "./CustomerScheme/pages/CustomerLogin";
import CustomerDashboard from "./CustomerScheme/pages/CustomerDashboard";
import SchemeSelection from "./CustomerScheme/pages/SchemeSelection";
import EnrollmentPage from "./CustomerScheme/pages/EnrollmentPage";
import PaymentPage from "./CustomerScheme/pages/PaymentPage";
import PaymentHistory from "./CustomerScheme/pages/PaymentHistory";
import SavingsRedemptionPage from "./CustomerScheme/pages/SavingsRedemptionPage";
import CustomerSchemeProtectedRoute from "./CustomerScheme/CustomerSchemeProtectedRoute";
import AdminPendingPayments from "./CustomerScheme/pages/AdminPendingPayments";

function App() {
  return (
    <>
      <div className="App">
        <Routes>
          <Route path="/" element={<Login />} />

          <Route path="/customer/login" element={<CustomerLogin />} />

          <Route element={<CustomerSchemeProtectedRoute />}>
            <Route path="/customer/dashboard" element={<CustomerDashboard />} />
            <Route path="/customer/schemes" element={<SchemeSelection />} />
            <Route path="/customer/enroll" element={<EnrollmentPage />} />
            <Route path="/customer/payment" element={<PaymentPage />} />
            <Route path="/customer/history" element={<PaymentHistory />} />
            <Route path="/customer/redeem" element={<SavingsRedemptionPage />} />
          </Route>

          <Route element={<ProtectedRoutes />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/billing" element={<Home />} />
            <Route path="/sales" element={<Sales />} />
            <Route path="/product" element={<AddProduct />} />
            <Route path="/stocks" element={<Stocks />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/stocksshort" element={<ShortageSTocks />} />
            <Route path="/all_branch_stocks" element={<Filter />} />
            <Route path="/CreateStore" element={<CreateStore />} />
            <Route path="/createuser" element={<CreateUser />} />
            <Route path="/createuser" element={<CreateUser />} />
            <Route path="/store" element={<Store />} />
            <Route path="/storestocks" element={<StoreStocks />} />
            <Route path="/storesales" element={<StoreSales />} />
            <Route path="/all_branch_salesList" element={<SalesFilter />} />
            <Route path="/gdigital/:id" element={<Gdigital />} />
            <Route path="/attendancereport" element = {<AttendanceReport/>} />
            <Route path="/hrattendancereport" element = {<HrAttendanceDashboard/>} />
            <Route path="/addexpenses" element= {<AddExpenses/>}/>
            <Route path="/expenses" element= {<Expenses/>}/>
            <Route path="/accountexpenses" element= {<AccountsExpenses/>}/>
            <Route path="/admin/pending-payments" element={<AdminPendingPayments />} />

            
          </Route>
        </Routes>
      </div>
    </>
  );
}

export default App;
